const skipStoreNotOpenDiolog = (
  availableServeTypes,
  availableTakeOutServeTypes
) => {
  // 當 availableServeTypes 只存在一個 "TAKE_OUT" 並且 availableTakeOutServeTypes 中只有 "SCHEDULE_TAKE_OUT"
  if (
    availableServeTypes.length === 1 &&
    availableServeTypes[0] === 'TAKE_OUT' &&
    availableTakeOutServeTypes.length === 1 &&
    availableTakeOutServeTypes[0] === 'SCHEDULE_TAKE_OUT'
  ) {
    return true;
  }

  // 當 availableServeTypes 只存在一個 "DELIVERY" 並且 availableTakeOutServeTypes 為空陣列
  if (
    availableServeTypes.length === 1 &&
    availableServeTypes[0] === 'DELIVERY' &&
    availableTakeOutServeTypes.length === 0
  ) {
    return true;
  }

  // 當 availableServeTypes 中只有 "TAKE_OUT" 和 "DELIVERY" 並且 availableTakeOutServeTypes 中只有 "SCHEDULE_TAKE_OUT"
  if (
    availableServeTypes.length === 2 &&
    availableServeTypes.includes('TAKE_OUT') &&
    availableServeTypes.includes('DELIVERY') &&
    availableTakeOutServeTypes.length === 1 &&
    availableTakeOutServeTypes[0] === 'SCHEDULE_TAKE_OUT'
  ) {
    return true;
  }

  // 其他情況都 return false
  return false;
};

export default skipStoreNotOpenDiolog;
